import api from '@/client/core/api'
import { DeleteTagsBulkAssignResponse, PutPostTagsBody } from '@/typings/twitter_benchmark_campaign_posts'

import { TwBenchmarkApiResponse, TwBenchmarkApiResult, handleApiResponse } from './twBenchmarkApiError'

/**
 * DELETE /twitter_benchmark_campaign_posts/:postId/tags/assign
 */
export async function deleteTwBenchmarkPostTagsAssign(
  postId: number,
  groupId: number,
  body: PutPostTagsBody
): Promise<TwBenchmarkApiResult<DeleteTagsBulkAssignResponse>> {
  const response = await api.delete<TwBenchmarkApiResponse<DeleteTagsBulkAssignResponse>>(
    `/twitter_benchmark_campaign_posts/${postId}/tags/assign`,
    { params: { groupId }, data: body }
  )

  return handleApiResponse<DeleteTagsBulkAssignResponse>(response)
}
